import React from 'react'
import PropTypes from 'prop-types'

const InfoIcon = ({ size }) => {
  return (
    <svg width={`${size}px`} height={`${size}px`} viewBox="0 0 18 18" version="1.1">
      <g id="desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="New-flow_02_multiple-tickets-(1)" transform="translate(-324.000000, -237.000000)">
          <g id="i" transform="translate(325.000000, 238.000000)">
            <g id="Group-7">
              <circle id="Oval-4-Copy" stroke="#A0A6AD" strokeWidth="1.472" cx="8" cy="8" r="8" />
              <path d="M9.0304,4.972 C9.0304,5.10880068 9.00340027,5.23659941 8.9494,5.3554 C8.89539973,5.47420059 8.82340045,5.57679957 8.7334,5.6632 C8.64339955,5.74960043 8.53540063,5.81799975 8.4094,5.8684 C8.28339937,5.91880025 8.15200068,5.944 8.0152,5.944 C7.72719856,5.944 7.48600097,5.84860095 7.2916,5.6578 C7.09719903,5.46699905 7,5.23840133 7,4.972 C7,4.84239935 7.02519975,4.71820059 7.0756,4.5994 C7.12600025,4.48059941 7.19799953,4.37800043 7.2916,4.2916 C7.38520047,4.20519957 7.49319939,4.13500027 7.6156,4.081 C7.73800061,4.02699973 7.87119928,4 8.0152,4 C8.15200068,4 8.28339937,4.02519975 8.4094,4.0756 C8.53540063,4.12600025 8.64339955,4.19439957 8.7334,4.2808 C8.82340045,4.36720043 8.89539973,4.46979941 8.9494,4.5886 C9.00340027,4.70740059 9.0304,4.83519932 9.0304,4.972 Z M7.1296,12.0676 L7.1296,6.6892 L8.9008,6.6892 L8.9008,12.0676 L7.1296,12.0676 Z" id="i-copy" fill="#A0A6AD" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

InfoIcon.propTypes = {
  size: PropTypes.number
}

InfoIcon.defaultProps = {
  size: 18
}

export default InfoIcon;
